module.exports = __webpack_public_path__ + "media/images/products/at2/at2-1-1000x1000-4f68805f35e5490ca8f9bbfd4ad2a47d.png";